<template>
  <div class="main-center" ref="middle">
    <img src="@/assets/img/driver1.png" style="width: 100%" alt="">
  </div>
</template>

<script>
import 'moment/locale/zh-cn'
export default {
  components: {

  },
  data() {
    return {
      img:false,
    };
  },
  filters: {

  },
  created() {

  },
  activated() {

  },
  mounted() {

  },
  deactivated() {

  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>


</style>
